export default __webpack_public_path__ + "static/media/40js.ad532269.svg";